/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Annual_DescriptionInputs */

const en_plan_annual_description = /** @type {(inputs: Plan_Annual_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One payment, year-long focus.`)
};

const es_plan_annual_description = /** @type {(inputs: Plan_Annual_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un solo pago, enfoque de todo el año.`)
};

/**
* | output |
* | --- |
* | "One payment, year-long focus." |
*
* @param {Plan_Annual_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_annual_description = /** @type {((inputs?: Plan_Annual_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Annual_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_annual_description(inputs)
	return en_plan_annual_description(inputs)
});